import api from '@/api'
import { ContactsStoredType, ContactFolderType } from '../types/enums'
import contact from './contact';
import Contacts from '../Index';

export default{
    /**
     * 폴더를 즐겨찾기 설정합니다.
     * @param item 주소록 폴더
     */
    setFavoriteFolder(item: contacts.FolderItem, type: ContactsStoredType): Promise<boolean> {
        const { id: id, isFavorite: isFavorite} = item;
        return api.post({
            url: '/api/contact/folder/set?type=' + type,
            data: {
                fields: [{ key: 'USER_IS_FAVORITE', value: `${isFavorite}` }],
                id: id.toString(),
                type: 'Folder',
            },
        });
    },

    /**
     * 
     * @param item 연락처
     * @param type 
     */
    setFavoriteContact(item: contacts.ContactItem, type: ContactsStoredType): Promise<boolean>{
        const { id: id, isFavorite: isFavorite } = item;
        return api.post({
            url: '/api/ews/contact/set?type=' + type,
            data:{
                fields: [
                    { key: 'USER_IS_FAVORITE', value: `${isFavorite}` }
                ],
                id: id.toString(),
                type: item.type === 'G' && item.storedType === ContactsStoredType.EWS ? 'ContactGroup' : 'Contact'
            }
        });
    },

    getFavoriteFolderList(parentId?: string){
        return api.post({
            url: '/api/contact/folder/list?type=' + ContactsStoredType.DB,
            data: {
                fields: [
                    { key: 'Id' },
                    { key: 'DisplayName' },
                    { key: 'TotalCount' },
                    { key: 'ChildFolderCount' },
                    { key: 'WellKnownFolderName' },
                    { key: 'USER_IS_FAVORITE' },
                    { key: 'USER_RENDER_ORDER' },
                ],
                filters: [
                    {
                        key: 'FolderClass',
                        value: 'IPF.Contact',
                        condition: 'isEqualTo',
                    },
                    {
                        key: 'USER_IS_FAVORITE',
                        value: 'true',
                        condition: 'isEqualTo'
                    }
                ],
                parentId: parentId,
                wellKnownParentName: 'Contacts',
                type: 'Folder',
                traversal: 'Shallow',
            },
        }).then((res: any) => {
            const lists = res.items.map((item: any) => {
                return {
                    ...item,
                    isFavorite: true,
                    nodeStatus: null,
                    oldStatus: null,
                    type: 'Favorite',
                    folderType: item.type === 'PC' ? ContactFolderType.PC : ContactFolderType.DC
                };
            })
            return lists;
        });
    },

    getPersonalFavoriteFolderList(wellKnownParentName: string, parentId?: string){
        return api.post({
            url: '/api/contact/folder/list?type=' + ContactsStoredType.EWS,
            data: {
                fields: [
                    { key: 'Id' },
                    { key: 'DisplayName' },
                    { key: 'TotalCount' },
                    { key: 'ChildFolderCount' },
                    { key: 'WellKnownFolderName' },
                    { key: 'USER_IS_FAVORITE' },
                    { key: 'USER_RENDER_ORDER' },
                ],
                filters: [
                    {
                        key: 'FolderClass',
                        value: 'IPF.Contact',
                        condition: 'isEqualTo',
                    },
                    {
                        key: 'USER_IS_FAVORITE',
                        value: 'true',
                        condition: 'isEqualTo'
                    }
                ],
                parentId: parentId,
                wellKnownParentName: wellKnownParentName,
                type: 'Folder',
                traversal: 'Shallow',
            },
        }).then((res: any) => {
            const lists = res.items.map((item: any) => {
                return {
                    ...item,
                    isFavorite: true,
                    nodeStatus: null,
                    oldStatus: null,
                    type: 'Favorite',
                    folderType: ContactFolderType.Personal
                };
            })
            return lists;
        });
    }
}